import * as React from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { cn } from '../lib/utils';

/**
 * Edge-anchored panel. Used for the navigation drawer below `md`, where a
 * permanent sidebar would cost a portrait tablet ~250px of table width.
 */
const Sheet = DialogPrimitive.Root;
const SheetTrigger = DialogPrimitive.Trigger;
const SheetClose = DialogPrimitive.Close;

const SheetContent = React.forwardRef<
  React.ComponentRef<typeof DialogPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Content> & {
    /** Only `left` is used today; the nav lives on the left. */
    side?: 'left';
  }
>(({ className, children, side = 'left', ...props }, ref) => (
  <DialogPrimitive.Portal>
    <DialogPrimitive.Overlay
      className={cn(
        'fixed inset-0 z-50 bg-ink/50',
        'data-[state=open]:animate-overlay-in data-[state=closed]:animate-overlay-out'
      )}
    />
    <DialogPrimitive.Content
      ref={ref}
      className={cn(
        'fixed inset-y-0 z-50 flex w-[280px] max-w-[85vw] flex-col bg-surface shadow-xl outline-none',
        side === 'left' && 'left-0 border-r border-line',
        'data-[state=open]:animate-sheet-in-left data-[state=closed]:animate-sheet-out-left',
        className
      )}
      {...props}
    >
      {children}
    </DialogPrimitive.Content>
  </DialogPrimitive.Portal>
));
SheetContent.displayName = DialogPrimitive.Content.displayName;

const SheetTitle = DialogPrimitive.Title;
const SheetDescription = DialogPrimitive.Description;

export { Sheet, SheetTrigger, SheetClose, SheetContent, SheetTitle, SheetDescription };
